import { Mail, Phone, Facebook, Instagram, Youtube } from 'lucide-react';
import { Separator } from "@/components/ui/separator";

export const Footer = () => {
  return (
    <footer className="bg-[#F1F0FB] py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo y descripción */}
          <div className="space-y-4 flex flex-col items-center md:items-start text-center md:text-left">
            <div className="w-[180px] h-[50px] relative">
              <img 
                src="https://media.financieramente.kids/logo-financieramente.png" 
                alt="FinancieraMente" 
                className="w-full h-full object-contain"
              />
            </div>
            <p className="text-sm text-gray-600">
              Construyendo un Futuro Exitoso para las Próximas Generaciones con Educación Financiera y Mentalidad Emprendedora!
            </p>
          </div>

          {/* Contacto */}
          <div className="space-y-4 flex flex-col items-center md:items-start">
            <h3 className="text-lg font-semibold text-primary">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-primary" />
                <a href="mailto:email@financieramente.kids" className="text-sm text-gray-600 hover:text-secondary transition-colors">
                  email@financieramente.kids
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-primary" />
                <a href="https://wa.me/59898801814" className="text-sm text-gray-600 hover:text-secondary transition-colors">
                  +598 98 801 814
                </a>
              </li>
            </ul>
          </div>

          {/* Redes Sociales */}
          <div className="space-y-4 flex flex-col items-center md:items-start">
            <h3 className="text-lg font-semibold text-primary">Síguenos</h3>
            <div className="flex gap-4">
              <a 
                href="https://facebook.com/financieramente.kids" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary hover:text-secondary transition-colors"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href="https://instagram.com/financieramente.kids" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary hover:text-secondary transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a 
                href="https://youtube.com/@financieramente-kids" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary hover:text-secondary transition-colors"
              >
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-gray-200" />

        <div className="text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} FinancieraMente.Kids - Derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};